import cloudServiceModule from '../cloudService.module';

class UserApiService {
    constructor(__env, $http, $q) {
        this.__env = __env;
        this.$http = $http;
        this.$q = $q;
    }

    getUserByUserGuid(userGuid) {
        if (!userGuid) {
            return this.$q.reject();
        }

        let deferred = this.$q.defer();
        this.$http
            .get(
                `${
                    this.__env.cloudApiUrl
                }/api/v1/appspace/accounts/users/${userGuid}`
            )
            .then(
                response => {
                    if (response.data) {
                        deferred.resolve({
                            firstName: response.data.FirstName,
                            lastName: response.data.LastName,
                            username: response.data.Username
                        });

                        return;
                    }

                    deferred.reject(response);
                },
                response => deferred.reject(response.data)
            );
        return deferred.promise;
    }

    getUserGroups(userGroupNameKeyword, resultLimit, sortCriteria, cloudToken) {
        const deferred = this.$q.defer();
        this.$http
            .get(`${this.__env.cloudApiUrl}/api/v2/users/usergroups`, {
                params: {
                    keyword: userGroupNameKeyword,
                    limit: resultLimit,
                    sort: sortCriteria
                },
                headers: {
                    token: cloudToken
                }
            })
            .then(
                response => {
                    deferred.resolve(response.data);
                },
                response => {
                    deferred.reject(response.data);
                }
            );

        return deferred.promise;
    }

    getUserGroup(userGroupId, cloudToken) {
        const deferred = this.$q.defer();
        this.$http
            .get(
                `${
                    this.__env.cloudApiUrl
                }/api/v2/users/usergroups/${userGroupId}`,
                {
                    headers: {
                        token: cloudToken
                    }
                }
            )
            .then(
                response => {
                    deferred.resolve(response.data);
                },
                response => {
                    deferred.reject(response.data);
                }
            );

        return deferred.promise;
    }
}

export default cloudServiceModule.service('userApiService', UserApiService);



// WEBPACK FOOTER //
// ./modules/cloudService/user/userApi.service.js